import { AmountInputCard } from './components/AmountInput';
import type { AmountInputProps } from './components/AmountInput.types';
import { ItemPrice } from './components/ItemPrice';
import type { ItemPriceProps } from './components/ItemPrice.types';

export const SelectionCard: React.FC<AmountInputProps | ItemPriceProps> = (props) => {
	const { type } = props;
	if (type === 'amountInput') return <AmountInputCard {...props} />;
	return <ItemPrice {...props} />;
};
